




export default {
  name: 'IconCloseMini',
};
